import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { ProtectedRoutes } from './core/guards/protected-routes.guard';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: 'adm',
        canActivate : [MsalGuard, ProtectedRoutes],
        loadChildren: () =>
          import('./modules/adm/adm.module').then(m => m.AdmModule)
      },
      {
        path: 'product',
        canActivate : [MsalGuard, ProtectedRoutes],
        loadChildren: () =>
          import('./modules/product/product.module').then(m => m.ProductModule)
      },
      {
        path: 'movement',
        canActivate : [MsalGuard, ProtectedRoutes],
        loadChildren: () =>
          import('./modules/movements/movements.module').then(m => m.MovementModule)
      },
      {
        path: 'mid',
        canActivate : [MsalGuard, ProtectedRoutes],
        loadChildren: () =>
          import('./modules/mid/mid.module').then(m => m.MidModule)
      },
      {
        path: 'error',
        loadChildren: () =>
          import('./modules/error/error.module').then(m => m.ErrorModule)
      },
      {
        path: 'config',
        canActivate : [MsalGuard, ProtectedRoutes],
        loadChildren: () =>
          import('./modules/config/config.module').then(m => m.ConfigModule)
      },
      {
        path: 'report',
        canActivate : [MsalGuard, ProtectedRoutes],
        loadChildren: () =>
          import('./modules/reports/reports.module').then(m => m.ReportsModule)
      },
      
    ]
  },
  {
    path: 'general-error',
    loadChildren: () =>
      import('./modules/error/error.module').then(m => m.ErrorModule)
  },
  { path: '**', redirectTo: 'error/PageNotFound' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
